import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';
import { BASE_URL } from '../../utils/constants';
import { getErrorMessage } from '../../utils/helper';

const SCHOOLS_ENDPOINT = 'school';

export const fetchSchools = createAsyncThunk(
  'schools/fetchSchools',
  async ({ search = '', page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${BASE_URL}${SCHOOLS_ENDPOINT}?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to fetch schools'));
    }
  }
);

export const createSchool = createAsyncThunk(
  'schools/create',
  async (schoolData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`${BASE_URL}${SCHOOLS_ENDPOINT}`, schoolData);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to create school'));
    }
  }
);

export const updateSchool = createAsyncThunk(
  'schools/update',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`${BASE_URL}${SCHOOLS_ENDPOINT}/${id}`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to update school'));
    }
  }
);

export const deleteSchool = createAsyncThunk(
  'schools/delete',
  async (schoolId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(`${BASE_URL}${SCHOOLS_ENDPOINT}/${schoolId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to delete school'));
    }
  }
); 